export const isDataManager = authorities => authorities.contains('ROLE_DATA_MANAGER');
